import { PRICE_CHANGED, PRICE_CHANGED_SEATSELL1 } from '@/src/constants/itineraryStatus'
import { Fare, ItineraryResponse, SmbMandatoryFareMapType, SmbMandatorySegmentMapType } from '@/src/types/itinerary'
import { getFares, getInsurances, getSelectedInsurance } from '@/src/utils/itinerary/flightTransformers'

export const transformItineraryData = (itineraryData: ItineraryResponse) => {
    const {
        flights,
        itineraryStatus,
        searchCriteria,
        vasAncillaries,
        meta,
        passengers,
        customer,
        fares,
        updatedFareResponse,
        currencyConversionDetails,
        paxPricingInfoJson
    } = itineraryData || {}

    const faresList = flights ? getFares(flights, paxPricingInfoJson, vasAncillaries) : []
    const insuranceList = vasAncillaries ? getInsurances(vasAncillaries) : []
    const selectedInsurances = insuranceList ? getSelectedInsurance(insuranceList) : []
    const isInsuranceTermsAndConditionsChecked = true
    const isPriceChange = [PRICE_CHANGED_SEATSELL1, PRICE_CHANGED].includes(itineraryStatus)

    const fareFamilyEnabledOnReview = meta?.fareFamilyEnabledOnReview
    let fareFamilyFares: Fare[] = []
    if (fareFamilyEnabledOnReview) {
        fareFamilyFares = fares
    }

    const smbMandatoryFareMap: SmbMandatoryFareMapType = {}

    if (fares?.length && flights?.length) {
        fares.forEach(fare => {
            const ctBrandName = fare?.fareGroupInformation?.ctBrandName || 'REGULAR'

            const smbMandatorySegmentMap: SmbMandatorySegmentMapType = {}

            if (fare.fareGroupInformationMap) {
                for (const [key, fareGroup] of Object.entries(fare.fareGroupInformationMap)) {
                    const flightIndex = parseInt(key, 10) - 1
                    const flight = flights[flightIndex]

                    // Map each segment to its SMB mandatory settings
                    flight.segments.forEach(segment => {
                        const segmentKey = `${segment.departAirport}_${segment.arrivalAirport}`
                        smbMandatorySegmentMap[segmentKey] = {
                            seat: fareGroup.seatMandatory,
                            meal: fareGroup.mealMandatory
                        }
                    })
                }
                smbMandatoryFareMap[ctBrandName] = smbMandatorySegmentMap
            }
        })
    }

    return {
        itineraryData,
        flights,
        itineraryStatus,
        searchCriteria,
        faresList,
        meta,
        passengers,
        customer,
        fareFamilyFares,
        currencyConversionDetails,
        insurance: {
            insuranceList,
            selectedInsurances,
            isInsuranceTermsAndConditionsChecked
        },
        metaData: {
            priceChangePopupData: {
                updatedFareResponse: updatedFareResponse || {},
                isPriceChange,
                priceChangePopupShown: false,
                oldPrice: updatedFareResponse?.oldPrice || 0,
                newPrice: updatedFareResponse?.totalPrice || 0
            }
        },
        smbMandatoryFareMap
    }
}
